import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { makeStyles } from '@material-ui/core'

export const useUnderMaintenanceStyles = makeStyles((theme) => ({
    overlayContainer: {
        height: '100%',
        alignContent: 'center',
        justifyItems: 'center',
        fontSize: pxToRem(20),
    },
    maintenanceTitle: {
        marginBottom: theme.spacing(3),
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
    errorDetails: {
        marginBottom: theme.spacing(3),
        color: theme.palette.error.main,
        maxWidth: '600px',
        wordBreak: 'break-word',
    },
}))
